/**
 * @deprecated No-op since anonymous auth replaced local-only guest mode.
 * Anonymous users now POST directly to the backend; no sign-up prompt needed after Create.
 */
export function useGuestMonkeyArenaLoginPrompt(): void {
  // No-op: anonymous users have a real Supabase session and game history.
}
